export const submerchantTree = (arr_submerchant) => {
    let arr_tree_submerchant = [ ...arr_submerchant ]
    for (let i = 0; i < arr_tree_submerchant.length; i++) {
        let sub = [];
        const id = arr_tree_submerchant[i].id;
        for (let j = 0; j < arr_tree_submerchant.length; j++) {
            if (id === arr_tree_submerchant[j].submerchantID) sub.push(j);
        }
        arr_tree_submerchant[i] = { ...arr_tree_submerchant[i], sub: sub}
    }
    return arr_tree_submerchant;
}

export const submerchantRootMerchant = (arr_submerchant, submerchantID) => {
    const root = arr_submerchant.filter((p) => p.submerchantID === submerchantID);
    return root[0];
}

export const submerchantRootSubmerchant = (arr_submerchant, idRoot) => {
    const root = arr_submerchant.filter((p) => p.id === idRoot);
    return root[0];
}

export const findRoot = (arr_submerchant) => {
    let root_arr = [];
    for (let i = 0; i < arr_submerchant.length; i++) {
        const index = arr_submerchant.findIndex((p) => p.id === arr_submerchant[i].submerchantID)
        if (index === -1)  root_arr.push(i);
    }
    return root_arr;
}

export const submerchantDfs = (arr_submerchant, idRoot) => {
    let arr_tree_submerchant = submerchantTree(arr_submerchant);

    let arr_submerchant_tree = [];

    function dfs(index, deepth) {
        const subWithDeep = {...arr_submerchant[index], level: deepth}
        arr_submerchant_tree.push(subWithDeep);
        if (arr_tree_submerchant[index].sub.length === 0) return ;
        else 
            for (let i of arr_tree_submerchant[index].sub) dfs(i, deepth + 1);
    }

    const root_arr = findRoot(arr_submerchant);
    for (let index of root_arr) dfs(index, 0);
    return arr_submerchant_tree;
}